window.LPProductForm = {
  skus: [],
  mandatorySKUs: [],
  wipeCart: false,
  goToCheckout: false,
  discountCode: null,
  debug: false,
  mock: false,

  log: {
    info: (...args) => {
      if (window.LPProductForm.debug) {
        console.log(
          `%cNP-LPForm`,
          "background: #3498db; color: white; padding: 2px 5px; border-radius: 3px;",
          "INFO:",
          ...args
        );
      }
    },
    success: (...args) => {
      if (window.LPProductForm.debug) {
        console.log(
          `%cNP-LPForm`,
          "background: #2ecc71; color: white; padding: 2px 5px; border-radius: 3px;",
          "SUCCESS:",
          ...args
        );
      }
    },
    error: (...args) => {
      if (window.LPProductForm.debug) {
        console.log(
          `%cNP-LPForm`,
          "background: #e74c3c; color: white; padding: 2px 5px; border-radius: 3px;",
          "ERROR:",
          ...args
        );
      }
    },
    warning: (...args) => {
      if (window.LPProductForm.debug) {
        console.log(
          `%cNP-LPForm`,
          "background: #f1c40f; color: white; padding: 2px 5px; border-radius: 3px;",
          "WARNING:",
          ...args
        );
      }
    },
  },

  init({
    wipeCart = false,
    goToCheckout = false,
    debug = false,
    mock = false,
    moneyFormat = "${{amount}}",
    currency = "USD",
  } = {}) {
    this.wipeCart = wipeCart;
    this.goToCheckout = goToCheckout;
    this.debug = debug;
    this.mock = mock;
    this.useSubscriptions = false;
    this.moneyFormat = moneyFormat;
    this.currency = currency;
    this.log.info("LPProductForm initialized", {
      wipeCart: this.wipeCart,
      goToCheckout: this.goToCheckout,
      debug: this.debug,
      mock: this.mock,
    });

    window.dispatchEvent(new CustomEvent("LPProductFormInit"));

    window.addEventListener("locGateSubsAdded", (event) => {
      this.log.warning(
        "Detected locGateSubsAdded, restricting to only subscriptions (when they exist)"
      );
      this.useSubscriptions = true;
    });
    if (window.locGated === true) {
      this.log.warning(
        "Detected locGateSubsAdded, restricting to only subscriptions (when they exist)"
      );
      this.useSubscriptions = true;
    }

    this.isInitialized = true;
  },

  // https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c?permalink_comment_id=5081916#gistcomment-5081916
  formatMoney(cents) {
    if (typeof cents == 'string') {
    cents = cents.replace('.', '');
    }
    
    // Fix for Euro currency where prices appear to be 100x too high in the data
    if (this.currency === "EUR" && typeof cents === "number") {
      cents = cents / 100;
    }
    
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = this.moneyFormat;
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
  },

  addSKU({
    sku,
    quantity,
    name,
    price,
    compareAtPrice,
    sellingPlanId = 0,
    sellingPlanPercentOff,
  }) {
    this.skus.push({
      sku,
      quantity,
      name,
      price,
      compareAtPrice,
      sellingPlanId,
      sellingPlanPercentOff,
    });
    this.log.info(
      `SKU ${sku} (${
        name || "unnamed"
      }) added with quantity ${quantity}, price ${price}, compareAtPrice ${compareAtPrice}, sellingPlanId ${sellingPlanId}, sellingPlanPercentOff ${sellingPlanPercentOff}`
    );
  },

  getSKUs() {
    return this.skus;
  },

  setSKUs(skus) {
    this.skus = skus;
    this.skus.push(...this.mandatorySKUs);
    this.log.info("setSKUs()", this.skus);
  },

  formatTotals(raw) {
    const formatted = {
      price: this.formatMoney(raw.price),
      nonSubscriptionPrice: this.formatMoney(raw.nonSubscriptionPrice),
      subscriptionPrice: this.formatMoney(raw.subscriptionPrice),
      compareAtPrice: this.formatMoney(raw.compareAtPrice),
      saved: this.formatMoney(raw.saved),
      percentageOff: raw.percentageOff,
      hasSubscriptions: raw.hasSubscriptions,
    };

    return formatted;
  },

  getRawTotals(item) {
    const raw = {};
    raw.price = item.price * item.quantity;
    raw.compareAtPrice = (item.compareAtPrice || item.price) * item.quantity;
    raw.hasSubscriptions = false;

    if (this.useSubscriptions && item.sellingPlanPercentOff > 0) {
      raw.hasSubscriptions = true;
      raw.nonSubscriptionPrice = raw.price;
      raw.price = raw.price * (1 - item.sellingPlanPercentOff / 100);
      raw.subscriptionPrice = raw.price;
    }
    raw.saved = (raw.compareAtPrice - raw.price) * item.quantity;
    raw.percentageOff = Math.floor((raw.saved / raw.compareAtPrice) * 100);

    return raw;
  },

  getTotal() {
    let hasSubscriptions = false;

    const total = this.skus.reduce(
      (acc, item) => {
        const raw = this.getRawTotals(item);
        acc.price += raw.price;
        acc.compareAtPrice += raw.compareAtPrice;
        acc.saved += raw.saved;

        if (raw.hasSubscriptions === true) {
          acc.subscriptionPrice += raw.subscriptionPrice;
        }
        acc.nonSubscriptionPrice += raw.nonSubscriptionPrice;

        acc.percentageOff = Math.floor((acc.saved / acc.compareAtPrice) * 100);
        acc.hasSubscriptions = acc.hasSubscriptions || raw.hasSubscriptions || false;

        return acc;
      },
      {
        price: 0,
        compareAtPrice: 0,
        saved: 0,
        percentageOff: 0,
        subscriptionPrice: 0,
        nonSubscriptionPrice: 0,
        hasSubscriptions: false,
      }
    );

    const percentageOff = Math.floor(
      (total.saved / total.compareAtPrice) * 100
    );
    this.log.info(total, percentageOff);

    const formatted = this.formatTotals(total);

    if (total.subscriptionPrice) {
      formatted.subscriptionPrice = this.formatMoney(total.subscriptionPrice);
    }

    const result = {
      total,
      formatted,
      hasSubscriptions,
    };

    this.log.info("getTotal()", result);
    return result;
  },

  getVariantTotals(item) {
    // Create a unique key for memoization
    const memoKey = `${item.sku}-${item.quantity}-${item.price}-${item.compareAtPrice}-${item.sellingPlanPercentOff}-${this.useSubscriptions}`;

    // Check if the result is already memoized
    if (this.variantTotalsMemo && this.variantTotalsMemo[memoKey]) {
      this.log.info("getVariantTotals() using memoized result", memoKey);
      return this.variantTotalsMemo[memoKey];
    }

    const raw = this.getRawTotals(item);
    const formatted = this.formatTotals(raw);

    if (item.packCount) {
      raw.pricePerPack = raw.price / item.packCount;
      formatted.pricePerPack = this.formatMoney(raw.pricePerPack);
    }

    const result = {
      raw,
      formatted,
    };

    // Memoize the result
    if (!this.variantTotalsMemo) {
      this.variantTotalsMemo = {};
    }
    this.variantTotalsMemo[memoKey] = result;

    return result;
  },

  addMandatorySKUs(skus) {
    this.log.info(
      "Mandatory SKUs added:",
      skus,
      "Existing:",
      this.mandatorySKUs
    );
    this.mandatorySKUs.push(...skus);
  },

  setDiscountCode(code) {
    this.discountCode = code;
    this.log.info(`Discount code set: ${code}`);
  },

  async submitCart() {
    this.log.info("addToCart()", this.skus);

    if (this.wipeCart === true) {
      this.log.info("Wiping cart");

      if (this.mock) {
        this.log.warning("MOCK: Wiping cart before new cart submission");
      } else {
        try {
          const response = await fetch("/cart/clear.js", { method: "POST" });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          this.log.success("Cart cleared successfully");
        } catch (error) {
          this.log.error("Error clearing cart:", error);
        }
      }
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/cart/add";

    this.skus.forEach((item, index) => {
      const skuInput = document.createElement("input");
      skuInput.type = "hidden";
      skuInput.name = `items[${index}][id]`;
      skuInput.value = item.sku;
      form.appendChild(skuInput);

      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = `items[${index}][quantity]`;
      qtyInput.value = item.quantity;
      form.appendChild(qtyInput);

      if (this.useSubscriptions && item.sellingPlanId > 0) {
        const sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = `items[${index}][selling_plan]`;
        sellingPlanInput.value = item.sellingPlanId;
        form.appendChild(sellingPlanInput);
      }
    });
    if (this.discountCode) {
      const discountInput = document.createElement("input");
      discountInput.type = "hidden";
      discountInput.name = "discount";
      discountInput.value = this.discountCode;
      form.appendChild(discountInput);
    }

    if (this.goToCheckout) {
      const checkoutTypeInput = document.createElement("input");
      checkoutTypeInput.type = "hidden";
      checkoutTypeInput.name = "return_to";
      checkoutTypeInput.value = "/checkout/";
      form.appendChild(checkoutTypeInput);
    }

    document.body.appendChild(form);
    const formData = new FormData(form);
    this.log.info("Submitting cart form", ...formData);

    if (this.mock) {
      this.log.warning("MOCK: Submitting form to:", form.action);
      return;
    }

    form.submit();
  },
};
